import { Link } from "react-router-dom";
import { Disc3 } from "lucide-react";

export default function NotFound() {
  return (
    <section className="relative min-h-[80vh] grid place-items-center pt-24 pb-16 px-5" data-testid="page-404">
      <div className="text-center">
        <span className="icon-chip !w-16 !h-16 mx-auto"><Disc3 size={28} /></span>
        <p className="eyebrow justify-center mt-6">404 — empty room</p>
        <h1 className="section-title mt-4">This room doesn't exist (yet).</h1>
        <p className="body-lg mt-4 max-w-md mx-auto">
          The track you're after isn't playing here. Head back to the floor.
        </p>
        <Link to="/" data-testid="notfound-home-link" className="btn-primary mt-8">
          Back to Tap In
        </Link>
      </div>
    </section>
  );
}
